import { render, staticRenderFns } from "./SwitchCheckbox.v2.vue?vue&type=template&id=b9439baa&scoped=true&"
import script from "./SwitchCheckbox.v2.vue?vue&type=script&lang=js&"
export * from "./SwitchCheckbox.v2.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCheckbox.v2.vue?vue&type=style&index=0&id=b9439baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9439baa",
  null
  
)

export default component.exports